var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"text-center",attrs:{"border-variant":"info","title":"..."}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.randomFact)+" ")]),_c('b-button',{attrs:{"variant":"outline-info"},on:{"click":_vm.generate}},[_vm._v(_vm._s(_vm.moreText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }